/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ComponentType = {
    delivery: 'delivery',
    cb: 'cb',
    cf: 'cf',
    manager: 'manager',
    cc: 'cc',
    kiosk: 'kiosk',
    adm: 'adm',
    profile: 'profile'
} as const;
export type ComponentType = typeof ComponentType[keyof typeof ComponentType];

